module.exports = __webpack_public_path__ + "static/Compute-Software-Services-Terms-and-Conditions-d9e09f1da61560542481314628141b04.pdf";